import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useModal from 'hooks/useModal';
import { AssignSpeakers as AssignSpeakersForm } from '@shoflo/polymer/components/AssignSpeakers/AssignSpeakers';
import { ASSIGN_SPEAKERS } from '@shoflo/polymer/constants/ModalTypes';
import { StudioLogger } from '@studio/logger/StudioLogger';
import { Modal, ModalBody } from 'reactstrap';
import updateSource from 'actions/source/updateSource';
import {
  getSpeakerSourcesFromRoles,
  getHostSourcesFromRoles
} from '@shoflo/studio-redux/utils/broadcastRolesHelper';
import { reduceSourceForLogs } from '@studio/sources/reduceSourceForLogs';
import { getSpeakerSources, getHostSources } from './utils';

const logger = new StudioLogger('presentation-control');

function AssignSpeakers() {
  const dispatch = useDispatch();
  const { isOpen, initialValue: pdfSource, clear } = useModal(ASSIGN_SPEAKERS);
  const sources = useSelector(state => state.broadcastSources.sources);
  const broadcastRoles = useSelector(state => state.broadcastRoles);

  const speakerSources = getSpeakerSources(sources);
  const hostSources = getHostSources(sources);

  const broadcastSpeakers = getSpeakerSourcesFromRoles(
    broadcastRoles,
    speakerSources
  );
  const broadcastHosts = getHostSourcesFromRoles(broadcastRoles, hostSources);

  useEffect(() => {
    const hostSourcesData = reduceSourceForLogs(broadcastHosts);
    const speakerSourcesData = reduceSourceForLogs(broadcastSpeakers);
    const presentation = {
      hostSourcesData,
      speakerSourcesData,
      source: pdfSource
    };
    if (isOpen) {
      logger.info(
        'Presentation Control - Host - Assign speakers modal opened',
        { presentation }
      );
    }
  }, [isOpen, broadcastHosts, broadcastSpeakers]);

  if (!pdfSource) {
    return;
  }

  const previouslySelectedSpeakers = pdfSource.value?.speakerUserIds ?? [];

  function onSave(selectedSpeakerIds) {
    const { value, _id: id } = pdfSource;
    value.speakerUserIds = selectedSpeakerIds;
    dispatch(updateSource(id, { value }, { showPdfNotification: true }));
    const assignedUsersSource = selectedSpeakerIds.map(source =>
      sources.find(s => s.user === source)
    );
    const presentation = {
      source: pdfSource,
      assignedUsersSource,
      selectedSpeakerIds
    };
    logger.info(
      'Presentation Control - Host - Speaker assigned to presentation',
      { presentation }
    );
    clear();
  }

  return (
    <Modal isOpen={isOpen} toggle={clear}>
      <ModalBody className="p-4">
        <AssignSpeakersForm
          hostSources={broadcastHosts}
          speakerSources={broadcastSpeakers}
          onSave={onSave}
          onCancel={clear}
          previouslySelectedSpeakers={previouslySelectedSpeakers}
        />
      </ModalBody>
    </Modal>
  );
}

export default AssignSpeakers;
